/**
 * @flow
 * Created by neo on 05.03.17.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import FlightOffer from '../../../Store/FlightOffer';
import FlightRouteMap from '../../../Components/Map';

type Props = {
  flightOffer: FlightOffer,
};

@observer
export default class FlightRoute extends React.Component<Props, void> {
  render() {
    const { props: { flightOffer: { route } } } = this;

    if (!route.points || route.points.length == 0) {
      // do not display map until we have route information
      return null;
    }

    return <FlightRouteMap route={route} />;
  }
}



// WEBPACK FOOTER //
// ./src/App/FlightOffer/View/FlightRoute/index.js